export function simpleHash(str: string): string {
	let hash = 5381;
	for (let i = 0; i < str.length; i++) {
		// Legit usage of bitwise operators
		// eslint-disable-next-line no-bitwise
		hash = ((hash << 5) + hash + str.charCodeAt(i)) >>> 0;
	}
	return hash.toString(36);
}
